import { Button, minValue, NumberInput, required, useListContext, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const LocateStudentInStudyGroupDialog = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useListContext();

  const educationIds = record?.selectedIds;

  const handleSubmit = async data => {
    const body = {
      educationIds,
      studyGroupId: Number(data.studyGroupId),
    };
    await dataProvider.customRequest(studentRequests.assignStudentsToStudyGroup(), body, "PUT");
    notify("Студентите бяха добавени в група успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Разпредели в група"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          startIcon={<PersonAddIcon />}
          size="medium"
          variant="contained"
          label="Разпредели в група"
        />
      }
    >
      <NumberInput
        source="studyGroupId"
        label="Учебна група"
        validate={[required(), minValue(1)]}
      />
    </FormModal>
  );
};

export default LocateStudentInStudyGroupDialog;
